import * as React from "react";
import { cn } from "@/utils/common.utils";

/** Reusable Stoop logo mark (the arch, without the wordmark). */
export function BrandLogo({ className, ...props }: React.ImgHTMLAttributes<HTMLImageElement>) {
  return <img src="/logo-mark.svg" alt="Stoop" className={cn("shrink-0 object-contain", className)} {...props} />;
}

interface GlobalLoaderProps extends React.HTMLAttributes<HTMLDivElement> {
  label?: string;
  description?: string;
  fullScreen?: boolean;
  compact?: boolean;
}

/** Branded loading state used while application-wide data is bootstrapping. */
export default function GlobalLoader({ label = "Loading Stoop…", description = "", fullScreen = true, compact = false, className = "", ...props }: GlobalLoaderProps) {
  return (
    <div
      className={cn(
        "flex w-full items-center justify-center bg-background",
        fullScreen ? "min-h-screen" : compact ? "min-h-40" : "min-h-[50vh]",
        className
      )}
      role="status"
      aria-live="polite"
      data-testid="global-loader"
      {...props}
    >
      <div className="flex flex-col items-center gap-4">
        <div className="relative flex size-20 items-center justify-center">
          <div className="absolute inset-0 animate-spin rounded-[1.35rem] border-2 border-moss/15 border-t-moss" />
          <BrandLogo className="size-10 animate-pulse" alt="" aria-hidden="true" />
        </div>
        <div className="text-center">
          <p className="text-sm font-semibold text-dash-ink">{label}</p>
          {description && <p className="mt-1 max-w-sm text-xs text-dash-muted">{description}</p>}
        </div>
      </div>
    </div>
  );
}
